"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HermisProvider = exports.TWalletAdapterNetwork = void 0;
exports.toWalletAdapterNetwork = toWalletAdapterNetwork;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var solana_headless_core_1 = require("@hermis/solana-headless-core");
var ContextProvider_1 = require("./ContextProvider");
var useStandardWalletAdapters_1 = require("../hooks/useStandardWalletAdapters");
/**
 * Convert {@link TWalletAdapterNetwork} (which includes Localnet) into the
 * upstream {@link WalletAdapterNetwork} enum understood by wallet adapters.
 * Localnet is mapped to Devnet for cluster-aware features since wallets do
 * not have a chain identifier for local validators.
 */
function toWalletAdapterNetwork(network) {
    if (network === TWalletAdapterNetwork.Localnet) {
        return solana_headless_core_1.WalletAdapterNetwork.Devnet;
    }
    // Mainnet/Devnet/Testnet share string values with WalletAdapterNetwork.
    return network;
}
/**
 * Props for the ContextProvider component
 */
var TWalletAdapterNetwork;
(function (TWalletAdapterNetwork) {
    TWalletAdapterNetwork["Mainnet"] = "mainnet-beta";
    TWalletAdapterNetwork["Devnet"] = "devnet";
    TWalletAdapterNetwork["Testnet"] = "testnet";
    TWalletAdapterNetwork["Localnet"] = "localnet";
})(TWalletAdapterNetwork || (exports.TWalletAdapterNetwork = TWalletAdapterNetwork = {}));
/**
 * Complete context provider with default adapters
 *
 * This component provides a complete setup for Solana wallet functionality
 * with default adapters (Phantom and Solflare) and automatic detection of
 * standard wallets.
 *
 * @param props ContextProviderProps
 * @returns Provider component
 */
var HermisProvider = function (_a) {
    var children = _a.children, endpoint = _a.endpoint, network = _a.network, _b = _a.autoConnect, autoConnect = _b === void 0 ? false : _b, _c = _a.storageKey, storageKey = _c === void 0 ? 'walletName' : _c, storageFactory = _a.storageFactory, _d = _a.wallets, wallets = _d === void 0 ? [] : _d, onError = _a.onError;
    var _e = (0, react_1.useState)([]), adapters = _e[0], setAdapters = _e[1];
    // Identity-stable key over the wallet set. Memoising on `.length` would
    // miss swaps where the array length stays the same but the wallets differ.
    var walletNamesKey = (0, react_1.useMemo)(function () { return wallets.map(function (w) { return w.name; }).join('|'); }, [wallets]);
    (0, react_1.useEffect)(function () {
        setAdapters(__spreadArray([], wallets, true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [walletNamesKey]);
    var allAdapters = (0, useStandardWalletAdapters_1.useStandardWalletAdapters)(adapters, endpoint, toWalletAdapterNetwork(network));
    return ((0, jsx_runtime_1.jsx)(ContextProvider_1.ContextProvider, { adapters: allAdapters, rpcEndpoint: endpoint, network: network, autoConnect: autoConnect, storageKey: storageKey, storageFactory: storageFactory, onError: onError, children: children }));
};
exports.HermisProvider = HermisProvider;
